import { EventApi, IdentifyApi } from 'api'
import store from 'config/store'
import { PageTrackEventAttributes } from 'modules/api/types'
import { pathOr } from 'ramda'
import { CustomAttributes, Identity } from 'types/user'
import { log, warn } from 'utils'



export const trackPageEvent = (attributes: PageTrackEventAttributes) => {
  try {
    trackEvent('Page', attributes)
  } catch(err) {
    warn(['Failed to send page event', err])
  }
}

export const trackEvent = (event: string, attributes: object) => {
  const { embed = {}, session = {} } = store.getState()

  const orgId = embed.orgId
  const userId = pathOr(null, ['externalId'], session)
  const userAgent = pathOr('', ['context', 'userAgent'], session)
  const inboxId = pathOr(null, ['configuration', 'inboxId'], embed)
  const anonymousId = pathOr(null, ['endUser', 'leadId'], session)
  const { id: embedId } = embed

  EventApi.post('/track', {
    orgId,
    inboxId,
    userId,
    attributes,
    event,
    embedId,
    context: {
      userAgent
    },
    anonymousId
  }).catch((error)=>{
    warn(['Failed to send page event', error])
  })
}

export const updateEndUserIdentity = (attributes: CustomAttributes, userId: any = null, options: Record<string, any>) => {
  const { embed, session } = store.getState()
  const { leadId } = session.endUser || {}
  const { userJwt: signedIdentity } = options || {}

  const body: Partial<Identity> = {
    attributes,
    userId: null,
    anonymousId: leadId,
    context: {},
    orgId: embed.orgId,
    signedIdentity,
    embedId: embed.id
  }

  if (userId) {
    body.userId = userId
  }

  return IdentifyApi.post(`/identify`, body)
    .catch((err) => {
      if(!!err.response && err.response.status === 402) {
        log({ type: 'warn', data: ['Unable to identify due to suspended org'] })
      } else {
        warn([`Failed to identify user via API - ${err.message}`])
      }
    })
}
